/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompatibleFirmwareResponse } from './compatible-firmware-response';


export interface GetCompatibleFirmwaresResponse { 
    equipmentIds?: Array<string> | null;
    compatibleFirmwares?: Array<CompatibleFirmwareResponse> | null;
}

